// extracted by mini-css-extract-plugin
module.exports = {"innerCursor":"mpY6M0","outerCursor":"y708eX","innerCursorStuck":"JTMKfl"};